import { render, staticRenderFns } from "./SubjectInfo.vue?vue&type=template&id=1ead02fe&scoped=true&"
import script from "./SubjectInfo.vue?vue&type=script&lang=js&"
export * from "./SubjectInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ead02fe",
  null
  
)

export default component.exports